import { useQuery, useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import http from 'helpers/http';
import { useNavigate } from 'react-router-dom';
interface LoginCredentials {
  email: string;
  password: string;
  loggedIn?: boolean;
}

interface User {
  id: number;
  name: string;
  email: string;
}

interface LoginResponse {
  user: User;
  token: string;
}

export function fetchSession() {
  return http.get('functions/v1/oak-server/auth/session');
}

export function useSession() {
  return useQuery({
    queryKey: ['auth'],
    queryFn: () => fetchSession(),
    retry: false
  });
}

export function useLogin() {
  const navigate = useNavigate();
  return useMutation(
    (formData: { email: string; password: string }) =>
      http.post('functions/v1/oak-server/auth/login', { ...formData }),
    {
      onSuccess: (_data, inputs) => {
        toast.success(`Logged in as ${inputs.email}`, {
          theme: 'colored'
        });
        console.log('logged in success', _data);
        localStorage.setItem('access_token', _data.access_token);
        localStorage.setItem('refresh_token', _data.refresh_token);
        console.log('navigate to dashboard');
        return navigate('/dashboard');
      },
      onError: error => {
        console.log(error);
        toast.error(`Invalid email or password.`, {
          theme: 'colored'
        });
      }
    }
  );
}

export function useLogout() {
  return useMutation(() => http.put('auth/logout'));
}

export function useSignup() {
  const navigate = useNavigate();
  const getAuth = useSession();
  return useMutation(
    (formData: { email: string; password: string; organizationName: string }) =>
      http.post('functions/v1/oak-server/auth/signup', { ...formData }),
    {
      onSuccess: async (_data, inputs) => {
        await getAuth.refetch();
        toast.success(`Logged in as ${inputs.email}`, {
          theme: 'colored'
        });
        navigate('/welcome?email=' + inputs.email);
      },
      onError: error => {
        toast.error('Error - please try again or contact support.', {
          theme: 'colored'
        });
      }
    }
  );
}
